// DUCKS pattern
import { createAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "@src/ducks/store";
import { LoginInput, ErrorValue, SignupWithPromoValue } from "../types";

export interface SignupState {
  loading: boolean;
  data: object;
  successSignup: boolean;
  error: ErrorValue;
}

export const initialState: SignupState = {
  loading: false,
  data: {},
  error: {} as ErrorValue,
} as SignupState;

// Slice
export const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    signupRequest: (state) => {
      state.loading = true;
      state.error = {} as ErrorValue;
    },
    signupSuccess: (state, action) => {
      state.data = action.payload;
      state.error = {} as ErrorValue;
      state.loading = false;
    },
    signupFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    signupPromoRequest: (state) => {
      state.loading = true;
      state.error = {} as ErrorValue;
    },
  },
});

// Actions
export const signupActions = {
  signupRequest: createAction(
    `${signupSlice.name}/signupRequest`,
    (params: LoginInput) => ({
      payload: params,
    })
  ),
  signupSuccess: signupSlice.actions.signupSuccess,
  signupFailure: signupSlice.actions.signupFailure,

  signupPromoRequest: createAction(
    `${signupSlice.name}/signupPromoRequest`,
    (params: SignupWithPromoValue) => ({
      payload: params,
    })
  ),
};

// Selectors
export const selectedSigningIn = (state: RootState) => state.signup.loading;
export const selectedSigningFailed = (state: RootState) => state.signup.error;
export const selectedSigningData = (state: RootState) => state.signup.data;

// Reducer
export default signupSlice.reducer;
